export default "__VITE_ASSET__52cd6107__"